module.exports = __webpack_public_path__ + "img/empty-not-finished.c1db2da3.svg";